import {z} from "../../../../../lib";
import {schemaEntityWithId} from "../../../../../types";
import {
  OperacionTransferenciaTercerosCuentaFields,
  OperacionTransferenciaTercerosDetalleFields,
  OperacionTransferenciaTercerosFields
} from "./fields";

export const schemaOperacionTransferenciaTerceros = z
  .object({
    [OperacionTransferenciaTercerosFields.CodPais]: z.number(),
    [OperacionTransferenciaTercerosFields.NombrePais]: z.string(),
    [OperacionTransferenciaTercerosFields.CodEstado]: z.number(),
    [OperacionTransferenciaTercerosFields.FechaAprobacion]: z.coerce.date(),
    [OperacionTransferenciaTercerosFields.AsesorFinanciero]: z.string(),
    [OperacionTransferenciaTercerosFields.NroOperacion]: z.string().nullable().optional(),
    [OperacionTransferenciaTercerosFields.Finalizada]: z.boolean().optional(),
    [OperacionTransferenciaTercerosFields.IdUsuarioAlta]: z.number(),
    [OperacionTransferenciaTercerosFields.NombreUsuarioAlta]: z.string(),
    [OperacionTransferenciaTercerosFields.ApellidoUsuarioAlta]: z.string(),
    [OperacionTransferenciaTercerosFields.MailUsuarioAlta]: z.string(),
    [OperacionTransferenciaTercerosFields.PermiteEditar]: z.boolean(),
    [OperacionTransferenciaTercerosFields.PermiteEliminar]: z.boolean(),
    [OperacionTransferenciaTercerosFields.VisualizaExpandidoCompliance]: z.boolean(),
    [OperacionTransferenciaTercerosFields.PermiteEditarCompliance]: z.boolean(),
    [OperacionTransferenciaTercerosFields.VisualizaExpandidoFinalizar]: z.boolean(),
    [OperacionTransferenciaTercerosFields.PermiteEditarFinalizar]: z.boolean(),
  })
  .merge(schemaEntityWithId)

export type OperacionTransferenciaTerceros = z.infer<typeof schemaOperacionTransferenciaTerceros>


export const schemaFormOperacionTransferenciaTerceros = z
  .object({
    [OperacionTransferenciaTercerosFields.CodPais]: z.number(),
    [OperacionTransferenciaTercerosFields.FechaAprobacion]: z.date(),
    [OperacionTransferenciaTercerosFields.AsesorFinanciero]: z.string(),
  })

export type FormOperacionTransferenciaTerceros = z.infer<typeof schemaFormOperacionTransferenciaTerceros>


const schemaDetalle = z
  .object({
    [OperacionTransferenciaTercerosDetalleFields.Sector]: z.string(),
    [OperacionTransferenciaTercerosDetalleFields.Moneda]: z.string(),
    [OperacionTransferenciaTercerosDetalleFields.Monto]: z.number(),
    [OperacionTransferenciaTercerosDetalleFields.Destino]: z.string(),
    [OperacionTransferenciaTercerosDetalleFields.MontoEquivalenteUSD]: z.number().nullable(),
    [OperacionTransferenciaTercerosCuentaFields.PermiteModificar]: z.boolean(),
    [OperacionTransferenciaTercerosCuentaFields.Estilo]: z.string().nullable(),
  })
  .merge(schemaEntityWithId)

export type CuentaTransferenciaTercerosDetalle = z.infer<typeof schemaDetalle>


export const schemaCuentaTransferenciaTerceros = z
  .object({
    [OperacionTransferenciaTercerosCuentaFields.NroCuenta]: z.string(),
    [OperacionTransferenciaTercerosCuentaFields.Titular]: z.string(),
    [OperacionTransferenciaTercerosCuentaFields.CodTipoOperacion]: z.number(),
    [OperacionTransferenciaTercerosCuentaFields.TipoOperacion]: z.string(),
    [OperacionTransferenciaTercerosCuentaFields.Broker]: z.string().nullable(),
    [OperacionTransferenciaTercerosCuentaFields.MSB]: z.string().nullable(),
    [OperacionTransferenciaTercerosCuentaFields.BancoReceptor]: z.string().nullable(),
    [OperacionTransferenciaTercerosCuentaFields.TitularCuenta]: z.string().nullable(),

    [OperacionTransferenciaTercerosCuentaFields.Detalles]: z.array(schemaDetalle)
  })
  .merge(schemaEntityWithId)

export const schemaCuentasTransferenciaTerceros = z.array(schemaCuentaTransferenciaTerceros)

export type CuentaTransferenciaTerceros = z.infer<typeof schemaCuentaTransferenciaTerceros>
export type CuentasTransferenciaTerceros = z.infer<typeof schemaCuentasTransferenciaTerceros>


